export default "__VITE_ASSET__Cja3EUQY__"